/**
 * Central API base URL for all backend calls.
 *
 * - Production: leave REACT_APP_BACKEND_URL empty → same-origin `/api/...` (HTTPS via Caddy).
 * - Local: REACT_APP_BACKEND_URL=http://localhost:8001
 *
 * If a prod build accidentally baked in http:// for the same host as the page,
 * upgrade to https so the browser does not block mixed-content XHR.
 */
function resolveBackendUrl() {
  const raw = (process.env.REACT_APP_BACKEND_URL || '').trim();
  if (!raw) return '';

  if (typeof window !== 'undefined' && window.location.protocol === 'https:') {
    try {
      const u = new URL(raw.startsWith('http') ? raw : `https://${raw}`);
      if (u.protocol === 'http:' && u.host === window.location.host) {
        return `https://${u.host}`;
      }
    } catch {
      // use raw value below
    }
  }

  return raw.replace(/\/+$/, '');
}

export const BACKEND_URL = resolveBackendUrl();

/** Build an API path. Empty base → relative same-origin URL. */
export function apiPath(path) {
  const p = path.startsWith('/') ? path : `/${path}`;
  return BACKEND_URL ? `${BACKEND_URL}${p}` : p;
}
